import React from 'react';
import { Camera } from 'lucide-react';

const ServicesCategoryTab = ({ vendorProfile }) => {
  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 sm:mb-6 gap-2">
        <h3 className="text-lg font-medium text-gray-900">Service Categories</h3>
        <span className="text-sm text-gray-500">{vendorProfile?.vendor_categories?.length || 0} categories</span>
      </div>
      
      {vendorProfile?.vendor_categories?.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {vendorProfile.vendor_categories.map((category, index) => (
            <div key={index} className="border border-gray-200 rounded-lg p-4">
              <div className="flex items-center justify-between mb-2">
                <h4 className="font-medium text-gray-900">{category.service_category?.category_name}</h4>
                {category.is_primary && (
                  <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800">
                    Primary
                  </span>
                )}
              </div>
              <p className="text-sm text-gray-600 mt-1">{category.service_category?.category_description}</p>
              <div className="mt-3 flex items-center justify-between">
                <span className="text-sm text-gray-500">
                  Type: {category.service_category?.service_type?.replace(/_/g, ' ')}
                </span>
                <span className={`px-2 py-1 text-xs rounded-full ${
                  category.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                }`}>
                  {category.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8">
          <Camera className="w-12 h-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-500">No service categories available</p>
        </div>
      )}

      {/* Specialties */}
      {(() => {
        // Ensure specialties is always an array
        let specialties = [];
        
        if (vendorProfile?.specialties) {
          if (Array.isArray(vendorProfile.specialties)) {
            specialties = vendorProfile.specialties;
          } else if (typeof vendorProfile.specialties === 'string') {
            try {
              specialties = JSON.parse(vendorProfile.specialties);
              if (!Array.isArray(specialties)) {
                specialties = [];
              }
            } catch (e) {
              // If parsing fails, treat as empty array
              specialties = [];
            }
          }
        }
        
        return specialties.length > 0 && (
          <div className="mt-8">
            <h4 className="text-lg font-medium text-gray-900 mb-4">Specialties</h4>
            <div className="flex flex-wrap gap-2">
              {specialties.map((specialty, index) => (
                <span key={index} className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-gray-100 text-gray-800">
                  {specialty}
                </span>
              ))}
            </div>
          </div>
        );
      })()}
    </div>
  );
};

export default ServicesCategoryTab;

